import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Button from './components/Button';
import Creator from './components/Creator';
import Table from './components/Table';
import Title from './components/Title';
import './components/style.css';


class App extends Component {
  render() {
    return (
      <div>
      <div className='header'><Title />
      <Button name='Advice' /></div>
      <Table />
      <Creator name='Chidwi' />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js